<template>
  <div class="app-login">
    <div class="login-container">
      <div class="login-box text-base">
        <dyn-slot :slot-data="slotData"><slot name="txtBefore"></slot></dyn-slot>
        <form @submit.prevent="login()" :id="'form' + _uid" :novalidate="true" data-form-login class="login-form">
          <div class="inputs-container">
            <div class="input-field">
              <label class="text-base-medium"
                ><dyn-slot :slot-data="slotData"><slot name="lblUsername">Username</slot></dyn-slot></label
              >
              <legend class="visually-hidden">Login Informationen</legend>
              <ValidationIndicator :dirty="$v.msisdn.$dirty" :valid="!$v.msisdn.$invalid">
                <input
                  id="'login-username-input_' + _uid"
                  class="input"
                  type="tel"
                  name="msisdn"
                  :placeholder="usernamePlaceholder"
                  data-msisdn
                  required
                  aria-required="true"
                  @input="msisdnFormatted"
                  @blur="$v.msisdn.$touch"
                  @click="$v.msisdn.$reset"
                  v-model.trim="msisdn"
                  :class="{
                    'input--invalid': $v.msisdn.$invalid && $v.msisdn.$dirty,
                    'input--valid': !$v.msisdn.$invalid && $v.msisdn.$dirty
                  }"
                  :disabled="loading"
                />
              </ValidationIndicator>
            </div>
          </div>
          <div class="input-field">
            <label class="text-base-medium"
              ><dyn-slot :slot-data="slotData"><slot name="lblPassword">Password</slot></dyn-slot></label
            >
            <ValidationIndicator :valid="isValid('password')" :dirty="$v.password.$dirty">
              <input
                id="'login-password-input_' + _uid"
                data-password
                type="password"
                required
                :placeholder="passwordPlaceholder"
                @input="$v.password.$touch"
                :class="{
                  'input--invalid': !isValid('password') && $v.password.$dirty,
                  'input--valid': isValid('password') && $v.password.$dirty
                }"
                v-model="password"
                :disabled="loading"
                class="input"
              />
            </ValidationIndicator>
          </div>
          <label class="col-form-label label-between" :for="'login-password_' + _uid"
            ><dyn-slot :slot-data="slotData"><slot name="lblBetween"></slot></dyn-slot
          ></label>
          <button :id="'submit-' + _uid" type="submit" class="button button--primary" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <slot name="btnNext">Login</slot>
          </button>
        </form>
        <dyn-slot :slot-data="slotData"><slot name="txtAfter"></slot></dyn-slot>
        <div class="text-base-medium text-align-center full-width">
          <a
            :href="pwResetUrl"
            aria-label="Link zum Erstellen eines neuen Passworts oder zum Zurücksetzen"
          >
            Neues Passwort erstellen / Passwort vergessen
          </a>
        </div>
      </div>
      <div class="app-box">
        <AppStoreCard />
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
import { onLogin } from '@/apollo'
import isValid from '@/mixins/isValid'
import AppStoreCard from '@/components-v2/flows/LIDL/App/AppStoreCard.vue'
import ValidationIndicator from '@/components-v2/generic/ValidationIndicator.vue'
import msisdnFormatter from '@/mixins/msisdnFormatter'
import preFilledInput from '@/mixins/preFilledInput'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9 ]*$/)

export default {
  name: 'Login',
  components: {
    AppStoreCard,
    ValidationIndicator
  },
  data() {
    return {
      password: '',
      loading: false
    }
  },
  props: {
    usernamePlaceholder: {
      type: String,
      default: 'Rufnummer'
    },
    passwordPlaceholder: {
      type: String,
      default: 'Passwort'
    },
    pwResetUrl: {
      type: String,
      default: 'neues-kennwort-anfordern.html'
    }
  },
  methods: {
    login() {
      if (this.$v.$invalid) {
        return
      }
      const component = this
      this.loading = true
      this.$store
        .dispatch('login', {
          username: this.msisdn.replace(/[ +]/g, ''),
          password: this.password
        })
        .then(
          jwt => {
            // login for apollo client
            onLogin(component.$apolloProvider.defaultClient, jwt)

            document.querySelectorAll('.disableOnLogout').forEach(elm => {
              elm.removeAttribute('disabled')
            })
            // login for cms
            const portalLoginForm = document.querySelector('form.mod_login')
            if (portalLoginForm) {
              portalLoginForm.querySelector('[name=username]').value = 'jwt'
              portalLoginForm.querySelector('[name=password]').value = jwt
              portalLoginForm.submit()
            } else {
              this.loading = false
            }
          },
          error => {
            if (error.response && error.response.data) {
              component.$store.commit('addError', error.response.data)
            } else if (error.message) {
              component.$store.commit('addError', { message: error.message })
            } else {
              component.$store.commit('addError', 'technical error!')
            }
            this.loading = false
          }
        )
    }
  },
  mixins: [validationMixin, isValid, msisdnFormatter, preFilledInput('msisdn', 'getMsisdn')],
  validations() {
    return {
      msisdn: {
        required,
        isPhoneNumber
      },
      password: {
        required
      }
    }
  },
  computed: {
    slotData() {
      return {
        username: this.msisdn,
        loading: this.loading
      }
    }
  }
}
</script>
